// Hook
import { useEffect, useState } from 'react';

export type DevType = 'mobile' | 'tablet' | 'desktop' | 'mini';

const getIsMini = () => {
  return window.matchMedia('screen and (max-width: 360px)').matches;
};
const getIsMobile = () => {
  return window.matchMedia('screen and (max-width: 764px)').matches;
};
const getIsTablet = () => {
  return window.matchMedia('screen and (max-width: 1199px)').matches;
};

const getDevType = () => {
  return getIsMini() ? 'mini' : getIsMobile() ? 'mobile' : getIsTablet() ? 'tablet' : 'desktop';
};

export function useWinResizeQuery(): {
  isMobile: boolean;
  isTablet: boolean;
  devType: DevType;
  isMini: boolean;
  winWidth: number;
  winHeight: number;
} {
  const [isMini, setIsMini] = useState(getIsMini());
  const [isMobile, setIsMobile] = useState(getIsMobile());
  const [isTablet, setIsTablet] = useState(getIsTablet());
  const [devType, setDevType] = useState<DevType>(getDevType());
  const [winWidth, setWinWidth] = useState(window.innerWidth);
  const [winHeight, setWinHeight] = useState(window.innerHeight);
  useEffect(() => {
    function handleResize() {
      // Set window width/height to state
      let mobile = false;
      let tablet = false;
      let mini = false;
      if (getIsMini()) {
        mini = true;
      }
      if (getIsMobile()) {
        mobile = true;
      }
      if (getIsTablet()) {
        tablet = true;
      }
      setIsMobile(mobile);
      setIsTablet(tablet);
      setIsMini(mini);
      setDevType(mini ? 'mini' : mobile ? 'mobile' : tablet ? 'tablet' : 'desktop');
      setWinWidth(window.innerWidth);
      setWinHeight(window.innerHeight);
    }

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return { isMobile, isTablet, devType, isMini, winWidth, winHeight };
}
